"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _EventModule = _interopRequireDefault(require("./Event.module.css"));

var staticImages = _interopRequireWildcard(require("../staticImages"));

var _reactTextfit = require("react-textfit");

var _JoinButton = _interopRequireDefault(require("./JoinButton"));

var _EventTimes = _interopRequireDefault(require("./EventTimes"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Event = /*#__PURE__*/function (_React$Component) {
  _inherits(Event, _React$Component);

  var _super = _createSuper(Event);

  function Event(props) {
    var _this;

    _classCallCheck(this, Event);

    _this = _super.call(this, props);
    _this.state = {
      live: false,
      curTime: Math.round(Date.now() / 1000),
      cal: null
    };
    _this.isLive = _this.isLive.bind(_assertThisInitialized(_this));
    _this.addtoCal = _this.addtoCal.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Event, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isLive();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.event !== this.props.event) {
        this.isLive();
      }
    }
  }, {
    key: "isLive",
    value: function isLive() {
      if (this.props.event.time[0] < this.state.curTime && this.state.curTime < this.props.event.time[1]) {
        this.setState({
          live: true
        });
      }
    }
  }, {
    key: "addtoCal",
    value: function addtoCal() {
      var _this2 = this;

      if (this.props.authenticator === "google") {
        var start = _momentTimezone["default"].utc(this.props.event.time[0] * 1000);

        var end = _momentTimezone["default"].utc(this.props.event.time[1] * 1000);

        var formated = start.format('YYYYMMDD') + "T" + start.format('HHmm') + "00Z/" + end.format('YYYYMMDD') + "T" + end.format('HHmm') + "00Z";
        var zoom = this.props.zoom;
        var name = this.props.event.name;
        var description = "Join " + this.props.name + " at " + zoom;

        if (!this.props.event.officialEvent) {
          name = name + " (" + this.props.name + ")";
        }

        if (zoom === "" || zoom === undefined) {
          zoom = "";
          description = this.props.name + " hasn't posted a link to this event yet";
        } else if (!zoom.toLowerCase().includes("https://")) {
          zoom = "https://" + zoom;
          description = "Join " + this.props.name + " club at " + zoom;
        }

        var link = "http://www.google.com/calendar/render?action=TEMPLATE";
        link = link + "&text=" + encodeURIComponent(name);
        link = link + "&dates=" + encodeURIComponent(formated);
        link = link + "&details=" + encodeURIComponent(description);
        link = link + "&location=" + encodeURIComponent(zoom);
        link = link + "&sf=false&output=xml";
        console.log(description);
        window.open(link, "_blank");
      } else {
        this.props.addToCal(this.props.event.uuid, this.props.zoom, function (blob) {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.style.display = 'none';
          a.href = url; // the filename you want

          a.download = "".concat(_this2.props.event.name, ".ics");
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.live) {
        if (this.props.type === "Single Live") {
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventModule["default"].large_name
          }, /*#__PURE__*/_react["default"].createElement(_reactTextfit.Textfit, {
            max: 20,
            mode: "single",
            className: _EventModule["default"].content,
            style: {
              height: "100%"
            }
          }, this.props.event.name)), /*#__PURE__*/_react["default"].createElement(_EventTimes["default"], {
            live: true,
            type: "large",
            start: this.props.event.time[0],
            end: this.props.event.time[1],
            timezone: this.props.timezone
          }), /*#__PURE__*/_react["default"].createElement(_JoinButton["default"], {
            zoom: this.props.zoom,
            errorPopup: this.props.errorPopup,
            type: "large",
            editMailingList: this.props.editMailingList
          }));
        } else if (this.props.type === "Top Live") {
          return /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventModule["default"].top_outer
          }, /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventModule["default"].top_name
          }, /*#__PURE__*/_react["default"].createElement(_reactTextfit.Textfit, {
            max: 16,
            mode: "single",
            className: _EventModule["default"].content,
            style: {
              height: "100%"
            }
          }, this.props.event.name)), /*#__PURE__*/_react["default"].createElement(_JoinButton["default"], {
            top: "18px",
            errorPopup: this.props.errorPopup,
            zoom: this.props.zoom,
            editMailingList: this.props.editMailingList
          }), /*#__PURE__*/_react["default"].createElement(_EventTimes["default"], {
            live: true,
            type: "top",
            start: this.props.event.time[0],
            end: this.props.event.time[1],
            timezone: this.props.timezone
          }));
        } else {}
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        id: _EventModule["default"].outer_div
      }, /*#__PURE__*/_react["default"].createElement(_EventTimes["default"], {
        type: this.props.type,
        live: this.props.live,
        start: this.props.event.time[0],
        end: this.props.event.time[1],
        timezone: this.props.timezone
      }), /*#__PURE__*/_react["default"].createElement("div", {
        id: _EventModule["default"].name,
        style: {
          color: this.props.color
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactTextfit.Textfit, {
        max: 13,
        mode: "single",
        className: _EventModule["default"].content,
        style: {
          height: "100%"
        }
      }, this.props.event.name)), this.props.live ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_JoinButton["default"], {
        top: "15px",
        errorPopup: this.props.errorPopup,
        zoom: this.props.zoom,
        editMailingList: this.props.editMailingList
      })) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        id: _EventModule["default"].join_button,
        onClick: this.addtoCal
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: _EventModule["default"].add_to
      }, "ADD TO"), /*#__PURE__*/_react["default"].createElement("img", {
        src: staticImages.NEW_CAL,
        id: _EventModule["default"].cal,
        alt: "calendar icon"
      }))));
    }
  }]);

  return Event;
}(_react["default"].Component);

var _default = Event;
exports["default"] = _default;

//# sourceMappingURL=Event.js.map